module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/153-cuba-41b07d1101e6609c8eac5a88d5065096.svg";